import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';

import { RouterFacade } from '../../../store/router.facade';

@Component({
  selector: 'app-breadcrumb',
  imports: [
    RouterModule,
    MatIconModule,
    MatTooltipModule,
    TranslatePipe,
    AsyncPipe,
  ],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppBreadcrumbComponent {
  private routerStore = inject(RouterFacade);
  private titleService = inject(Title);
  private translateService = inject(TranslateService);

  public routeData$ = this.routerStore.routerData$.pipe(
    switchMap((data) => (data && data['title']) ? this.translateService.get(data['title']).pipe(
      map((translatedTitle) => ({
        data,
        translatedTitle,
      }))
    ) : of(null)),
    filter(Boolean),
    tap(({ translatedTitle }) => {
      this.titleService.setTitle(translatedTitle);
    }),
    map(({ data }) => data),
  );
}
